import { Fragment } from 'react';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchableMenuBody(props) {
    const { children } = props;
    const { items, open, setOpen } = useSearchableMenu();
    const renderProps = {
        items,
        open,
        setOpen,
    };
    const renderItems = () => {
        if (typeof children === 'function') {
            return <Fragment>{children(renderProps)}</Fragment>;
        }
        return children;
    };
    return renderItems();
}
